import { COVERGO_SAAS_DEV, COVERGO_ASIA_PRE_PROD, COVERGO_ASIA_UAT, COVERGO_SAAS_PROD } from "../consts.js"

export const asiaeb = {
	"asia-health-dev-studio.quote.hk": {
		appConfig: {
			tenantId: "asia_dev",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
	"asia-studio.preprod.asia.covergo.cloud": {
		appConfig: {
			tenantId: "asia_preprod",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_PRE_PROD,
	},
	"asia-studio.uat.asia.covergo.cloud": {
		appConfig: {
			tenantId: "asia_uat",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_UAT,
	},
	"asia-studio.asia.covergo.com": {
		appConfig: {
			tenantId: "asia_prod",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_PROD,
	},
}
